
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import Draw from '@/utils/draw'
import COVERAPP from '@/utils/COVERAPP'

@Options ({
    data () {
        return {
            isOpening: false,
            isOpened: false,
            hbData: null,
            blessings: ['这一年，有你的陪伴才特别温暖！', '2020跟封面一起成长，2021继续与封面前行。', '下一年，继续跟着封面一路走红吧！', '封面想做你的记录者，2021继续陪着你。', '看见封面的力量，看见自己的小幸福。', '喜欢美好，喜欢陪伴，一起加油呀！', '在封面，体会平凡的可贵，生活的美好。', '你不孤独，在封面会遇见很多有趣儿的人。'],
            blessing: '',
            isDrawing: false,
            isDrawed: false,
            imgUrl: '',
            tags: ['封面新人', '进阶担当', '忠实粉丝', 'C位挚友']
        }
    },
    props: ['data'],
    computed: {
        ...mapState(['aid', 'shareData', 'userInfo', 'yearData'])
    },
    created () {
        this.SET_HBDATA(true)
        this.hbData = this.data == true ? null : this.data
        if (!this.hbData) {
            this.getHb()
        }
    },
    methods: {
        ...mapMutations(['SET_DIALOGDATA', 'SET_HBDATA']),
        open () {
            if (!this.isOpened && this.hbData.amount) {
                if (this.isOpening) return
                this.isOpening = true
                this.$request('/lottery/cash', {
                    aid: this.aid,
                    pid: this.hbData.pid
                }, 'put').then((data: any) => {
                    this.isOpened = true
                    this.isOpening = false
                }).catch((res: any) => {
                    if (res && res.errno == 1001 && res.errmsg == 'V2_ACCOUNT_SIMPLE_BAN') {
                        this.SET_DIALOGDATA({
                            text: '您的微信未实名认证，不能领取红包，<br>请实名认证后领取',
                            btns: [
                                {
                                    text: '确定'
                                }
                            ]
                        })
                    } else if (!res || !res.errno || (res.errno && res.errno != 1250 && res.errno != 1010)) {
                        this.$common.toast('加载失败，请重试！')
                    }
                    this.isOpening = false
                })
            } else {
                this.isOpened = true
            }
            this.$common.track(this.aid, 'click', '拆红包')
        },
        getHb () {
            this.blessing = this.blessings[Math.floor(Math.random() * this.blessings.length)]
            this.$request('/lottery/luck', {
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data: any) => {
                data.amount = (data.amount / 100).toFixed(2)
                this.hbData = data
            }).catch(() => {
                this.hbData = {}
            })
        },
        back () {
            this.$common.track(this.aid, 'click', '返回首页')
            this.$router.push({
                path: '/'
            })
        },
        share () {
            const _this = this
            _this.isDrawing = true
            this.isDrawed = true
            if (_this.imgUrl) {
                _this.shareImage(_this.imgUrl)
                return
            }
            if (this.yearData) {
                new Draw({
                    times: this.yearData.use_count,
                    days:  this.yearData.use_days,
                    news: this.yearData.news_read_cnt,
                    integrals: this.yearData.score_get_num || 0,
                    tag: this.tags[this.yearData.grade - 1],
                    amount: (this.hbData && this.hbData.amount) || 0,
                    sucessCallback (url: string) {
                        _this.imgUrl = url
                        _this.shareImage(_this.imgUrl)
                        _this.isDrawing = false
                    },
                    errCallback () {
                        _this.isDrawing = false
                    }
                })
            } else {
                new Draw({
                    noData: true,
                    amount: (this.hbData && this.hbData.amount) || 0,
                    sucessCallback (url: string) {
                        _this.imgUrl = url
                        _this.shareImage(_this.imgUrl)
                        _this.isDrawing = false
                    },
                    errCallback () {
                        _this.isDrawing = false
                    }
                })
            }      
        },
        shareImage (url: string) {
            const _this = this
            COVERAPP.Method.shareImage({
                title: _this.shareData.title,
                desc: _this.shareData.desc,
                imgUrl: _this.shareData.imgUrl,
                link: _this.shareData.link,
                image: url.split(';base64,')[1],
                callback () {
                    _this.$common.track(_this.aid, 'share', '分享图片')
                }
            })
            _this.isDrawing = false
        }
    }
})
export default class HongBao extends Vue {}
